import { FC } from 'react';
// import { CopyToClipboard } from 'react-copy-to-clipboard';
import Button from '../Button';
import Toast from '../Toast';
import styles from './index.less';


export enum MessageType {
  text = 1,
  image = 2,
  link = 3,
  weapp = 4,
  activity = 5
}

export interface WechatMessageContent {
  text: string;
  title: string;
  picUrl: string;
  desc: string;
  url: string;
  actId: string;
  name: string;
  appId: string;
  page: string;
}

export interface WechatMessageProps {
  type: keyof typeof MessageType;
  data: WechatMessageContent;
}

const renderCard = (title: string, description: string, image: string, link: string) =>
  <a href={link} className={styles.card} target='__blank'>
    <div className={styles.cardText}>
      <h5 className={styles.cardTitle}>{title}</h5>
      <p className={styles.cardDescription}>{description}</p>
    </div>
    <div className={styles.cardImage}>
      <img src={image} alt={title} />
    </div>
  </a>

const onCopy = text => {
  wx.setClipboardData({
    data: text,    // 设置的
    success: function(res) {
      Toast.success('已复制到剪切板', 1000)
    },
    fail: function() {
      Toast.error('您的企业微信版本过低，请升级最新版本！', 1000)
    }
  })
}

const WechatMessage: FC<WechatMessageProps> = ({ type = 'text', data }) => {
  let device = '';
  if (navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)) {
    device = 'phone';
  } else {
    device = 'PC';
  }

  const NEW_LINE = 'þ_enter_þ';
  const { title, desc, picUrl, url } = data;
  let { text } = data;
  const replaceText = text && text.replace(new RegExp(NEW_LINE,"gm"),'\n')
  // const replaceText = text && text.replaceAll(NEW_LINE, '\n');
  switch (type) {
    case 'link':
      return renderCard(title, desc, picUrl, url);
    case 'image':
      return (
        <div className={styles.image}>
          <img src={picUrl} alt={title} />
          <span className={styles.imageTip}>{device === 'PC' ? '提示: 右键图片保存' : '提示：长按图片保存'}</span>
        </div>
      )
    case 'text':
    default:
      return (
        <div className={styles.text}>
          {replaceText}
          {
            replaceText &&  <div onClick={() => onCopy(replaceText)} >
            <Button type='link' size='small' className={styles.copyBtn}>复制</Button>
          </div>
          }
        </div>
      )
  }
}
export default WechatMessage;
